import { FinancialServiceProviderAdapters } from '@seapoint/server/enums';

import logoStripe from '../../../assets/images/logo-stripe.svg';
import { VendorView } from '../../../types/entity-types';

/**
 * Maps provider types to their local logo assets.
 * Add new providers here when their logos are added to assets/images/
 */
const PROVIDER_LOGO_MAP: Partial<Record<FinancialServiceProviderAdapters, string>> = {
  [FinancialServiceProviderAdapters.STRIPE]: logoStripe,
};

/**
 * Maps known vendor names to their provider type for logo resolution.
 * Used when vendors don't have a provider field but need local assets.
 */
const VENDOR_NAME_TO_PROVIDER: Record<string, FinancialServiceProviderAdapters> = {
  Stripe: FinancialServiceProviderAdapters.STRIPE,
  'Stripe VAT': FinancialServiceProviderAdapters.STRIPE,
};

/**
 * Get the logo URL for a vendor.
 * If the vendor name matches a known provider, returns the local asset path.
 * Otherwise, returns the vendor's logo URL directly.
 */
export function getVendorLogo(
  vendorName: string | undefined,
  vendorLogo: string | undefined | null,
): string | undefined {
  if (vendorName) {
    const provider = VENDOR_NAME_TO_PROVIDER[vendorName];
    if (provider && PROVIDER_LOGO_MAP[provider]) {
      return PROVIDER_LOGO_MAP[provider];
    }
  }
  return vendorLogo ?? undefined;
}

export type VendorDetails = {
  logo: string | undefined;
  name: string;
};

/**
 * Get display details for a vendor.
 * Resolves the logo to a local asset if the vendor name matches a known provider.
 */
export function getVendorDetails(vendor: Pick<VendorView, 'name' | 'logo'>): VendorDetails {
  return {
    logo: getVendorLogo(vendor.name, vendor.logo),
    name: vendor.name,
  };
}
